"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
const redalerts_theme_palette_1 = require("@redwigwam/redalerts.theme.palette");
const headingFonts = ["Montserrat", "sans-serif"].join(", ");
const bodyFonts = ["Arimo", "sans-serif"].join(", ");
exports.typography = {
    fontSize: 16,
    fontFamily: bodyFonts,
    fontWeight: 400,
    color: redalerts_theme_palette_1.palette.body.main,
    body: {
        fontFamily: bodyFonts,
    },
    button: {
        fontFamily: headingFonts,
        fontWeight: 600,
        lineHeight: 1,
        textTransform: "unset",
    },
    h1: {
        fontSize: "1.5em",
        fontFamily: headingFonts,
        fontWeight: 600,
        lineHeight: 1,
        margin: "1.5em 0",
    },
    h2: {
        fontSize: "1.25em",
        fontFamily: headingFonts,
        fontWeight: 500,
        lineHeight: 1,
        margin: "1.25em 0",
    },
    h3: {
        fontSize: "1.2em",
        fontFamily: bodyFonts,
        fontWeight: 500,
        lineHeight: 1,
        margin: "1.2em 0",
    },
    h4: {
        fontSize: "1.1em",
        fontFamily: bodyFonts,
        fontWeight: 500,
        lineHeight: 1,
        margin: "1.1em 0",
    },
    h5: {
        fontSize: "1em",
        fontFamily: bodyFonts,
        fontWeight: 400,
        lineHeight: 1,
        margin: "1em 0",
    },
    h6: {
        fontSize: "1em",
        fontFamily: bodyFonts,
        fontWeight: 300,
        lineHeight: 1,
        margin: "1em 0",
    },
};
//# sourceMappingURL=typography.js.map